import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';

import { HeaderAppearanceEvents } from '@unicup-ticketing/core';
import { Dispatcher } from '@ngrx/signals/events';

@Component({
  selector: 'ticketing-about-the-draw',
  imports: [],
  templateUrl: './about-the-draw.component.html',
  styleUrl: './about-the-draw.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AboutTheDrawComponent implements OnInit {
  private readonly dispatcher = inject(Dispatcher);

  ngOnInit(): void {
    this.dispatcher.dispatch(HeaderAppearanceEvents.requestUnhero());
  }
}
